import { useEffect, useRef } from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { useTimeRemaining } from "hooks/use_time_remaining";
import { selectActiveBreakoutSession } from "store/selectors/classroom";
import { playBreakoutAudio, playTickingAudio, stopTickingAudio } from "utils/audio";

const TICKING_SOUND_STARTS_AT_MS = 11 * 1000;

function BreakoutAudioObserver() {
  const firstRender = useRef(true);
  const breakoutSession = useAppSelector(selectActiveBreakoutSession());
  const breakoutEndDate = breakoutSession?.ended_on ? new Date(breakoutSession.ended_on) : null;
  const { timeRemainingMs } = useTimeRemaining(breakoutEndDate);
  const timeToStartTickingHasPassed = !!(
    timeRemainingMs && timeRemainingMs <= TICKING_SOUND_STARTS_AT_MS
  );

  useEffect(() => {
    if (!breakoutSession?.id) return;
    if (timeToStartTickingHasPassed) {
      playTickingAudio();
    } else {
      stopTickingAudio();
    }
  }, [breakoutSession?.id, timeToStartTickingHasPassed]);

  // Play breakout audio when a breakout session starts or ends but ignore the first render
  useEffect(() => {
    if (firstRender.current) return;
    stopTickingAudio();
    playBreakoutAudio();
  }, [breakoutSession?.id]);

  useEffect(() => {
    firstRender.current = false;
  }, []);

  return null;
}

export { BreakoutAudioObserver };
